export enum PortalOutletName {
  modalOverlay = 'portalOutletName'
}
